import api from "@utils/api.client"
import type { CreateServiceRequestPayload, ServiceRequest, ServiceRequestStatus } from "./types"

export const serviceRequestsApi = {
  async list() {
    const response = await api.get<ServiceRequest[]>("/service-requests")
    return response.data
  },

  async create(payload: CreateServiceRequestPayload) {
    const response = await api.post<ServiceRequest>("/service-requests", payload)
    return response.data
  },

  async uploadAttachment(file: File) {
    const data = new FormData()
    data.append("file", file)
    const response = await api.post<NonNullable<CreateServiceRequestPayload["attachments"]>[number]>("/service-requests/attachments", data, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 30000,
    })
    return response.data
  },

  async updateStatus(id: string, status: ServiceRequestStatus) {
    const response = await api.patch<ServiceRequest>(`/service-requests/${id}/status`, { status })
    return response.data
  },

  async addMessage(id: string, text: string) {
    const response = await api.post<ServiceRequest>(`/service-requests/${id}/messages`, { text })
    return response.data
  },
}
